import {getData, LOGIN, USER_DATA} from "../storage";
import {isEmpty} from "../utility";
import sb from "../sendbird";


const getChatUserType = (user_type, callback) => {
    getData(USER_DATA)
        .then((data) => {
            if (!isEmpty(data)) {
                let userTypeObj = data.hasOwnProperty("chat") &&
                    data.chat &&
                    data.chat.hasOwnProperty(user_type) &&
                    data.chat[user_type] &&
                    data.chat[user_type].hasOwnProperty("user_id") &&
                    data.chat[user_type];
                callback(userTypeObj)
            } else {
                callback(null)
            }
        });
}

const sendBirdLogin = (user_type, successCallback, errorCallback) => {

    getChatUserType(user_type, (userTypeObj) => {

        if(userTypeObj){
            console.log(`sendBirdLogin >> user_type >> ${user_type} userTypeObj`, userTypeObj);

            const userID = userTypeObj["user_id"],
                sessionToken = userTypeObj["access_token"];

            sb.sbConnect(userID,
                sessionToken,
                (user) => {
                    console.log("sbConnect >> successCallback", user);
                    successCallback && successCallback(user);
                }, (error) => {
                    console.log("sbConnect >> errorCallback", error)
                    errorCallback && errorCallback(error);
                })
        }
    });
}

export default {
    sendBirdLogin
}